import { useState } from 'react'
import Layout from '../../components/Layout/Layout'
import './Contact.css'

const LINKEDIN_URL = 'https://www.linkedin.com/in/dele-akinfenwa-9131b79b/'

// Web3Forms emails each submission to the address this key was created for.
// The key is meant to be public, so it is safe to keep in the code.
const WEB3FORMS_ACCESS_KEY = 'bc8bb7d6-bceb-43a4-9ea9-9d9c36561a04'

const emptyForm = { name: '', email: '', message: '', botcheck: false }

export default function Contact() {
  const [form, setForm] = useState(emptyForm)
  const [status, setStatus] = useState('idle')

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target
    setForm({ ...form, [name]: type === 'checkbox' ? checked : value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setStatus('sending')
    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          subject: `You have a new message from ${form.name}`,
          from_name: 'Portfolio contact form',
          ...form,
        }),
      })
      const result = await res.json()
      if (!result.success) throw new Error(result.message)
      setForm(emptyForm)
      setStatus('sent')
    } catch (err) {
      setStatus('error')
    }
  }

  return (
    <Layout>
      <div className='contact'>
        <div className='contact-panel'>
          <h1 className='contact-title'>
            <span className='crimson'>L</span>et's <span className='crimson'>T</span>alk
          </h1>
          <p className='contact-lead'>
            Whether it's a role, a project, or just a question about something you saw here, I'd love to hear from you. Send a note below and I'll get back to you soon.
          </p>

          {status === 'sent' ? (
            <div className='contact-success' role='status'>
              <h2>Thanks for reaching out!</h2>
              <p>Your message is on its way. I'll be in touch shortly.</p>
              <button type='button' className='contact-button' onClick={() => setStatus('idle')}>
                Send another message
              </button>
            </div>
          ) : (
            <form className='contact-form' onSubmit={handleSubmit}>
              <input
                type='checkbox'
                name='botcheck'
                className='contact-hidden'
                tabIndex='-1'
                autoComplete='off'
                checked={form.botcheck}
                onChange={handleChange}
              />

              <div className='contact-row'>
                <label className='contact-field'>
                  <span>Name</span>
                  <input
                    type='text'
                    name='name'
                    autoComplete='name'
                    required
                    value={form.name}
                    onChange={handleChange}
                  />
                </label>
                <label className='contact-field'>
                  <span>Email</span>
                  <input
                    type='email'
                    name='email'
                    autoComplete='email'
                    required
                    value={form.email}
                    onChange={handleChange}
                  />
                </label>
              </div>

              <label className='contact-field'>
                <span>Message</span>
                <textarea
                  name='message'
                  rows='6'
                  required
                  value={form.message}
                  onChange={handleChange}
                />
              </label>

              {status === 'error' && (
                <p className='contact-error' role='alert'>
                  Something went wrong sending your message. Please try again, or reach me on LinkedIn.
                </p>
              )}

              <button type='submit' className='contact-button' disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending…' : 'Send message'}
              </button>
            </form>
          )}

          <div className='contact-divider'>
            <span>or connect with me on</span>
          </div>

          <a className='contact-linkedin' href={LINKEDIN_URL} target='_blank' rel='noopener noreferrer'>
            <svg viewBox='0 0 24 24' aria-hidden='true'>
              <path d='M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z' />
            </svg>
            LinkedIn
          </a>
        </div>
      </div>
    </Layout>
  )
}
